// @ts-expect-error untyped
import { atom, swap } from 'atom';
// @ts-expect-error untyped
import tinymce from 'tinymce';
import { getAtomValue } from '../data/atomUtils';
import { CLEAR_INTERNAL_ACTIVE_EDTIOR_EVENT_NAME, internalActiveEditorAtom } from './activeEditorAtom';
const isListenerInitialized = atom(false);
function handleClearActiveEditorEvent() {
  // If there is an editor focused, do not clear the active editor
  if (tinymce.focusedEditor) {
    return;
  }
  swap(internalActiveEditorAtom, () => null);
}
export default function initializeClearActiveEditorListener() {
  if (getAtomValue(isListenerInitialized)) {
    return;
  }
  document.addEventListener(CLEAR_INTERNAL_ACTIVE_EDTIOR_EVENT_NAME, handleClearActiveEditorEvent);
  swap(isListenerInitialized, () => true);
}